import React from "react";
import Header from "../../Partials/Header/Header";
import Footer from "../../Partials/Footer/Footer";
import Body from "./Body";


export default class Contact extends React.Component {
    render() {
        return (
            <div className="integrator-wrapper">
                <Header />
                <Body />

                <Footer />
            </div>
        );
    }
}